import { jwtDecode } from 'jwt-decode';
import { msalInstance } from '../..';
import { b2cClientId, b2cScopeEndPoint, b2cTenant } from '../configurations';

export function Roles (roles: string[], userRoles: string[]):boolean {
    if(userRoles.length<=0)
        return false;
    let result:boolean=false;
    // eslint-disable-next-line array-callback-return
    roles.map(role =>{
        if(userRoles.indexOf(role)>=0)
            result = true;
    });
    return result;
};

interface DecodedToken {
  exp: number; // Expiration time (as Unix timestamp)
  iat: number; // Issued at (as Unix timestamp)
  // You can include other properties from the token as needed
}

export function isTokenExpired(token: string): boolean {
  const currentTime = new Date().getTime() / 1000; // Convert to Unix timestamp
  const decoded: DecodedToken = jwtDecode(token);

  return decoded.exp > currentTime;
}

// Example function to acquire a token silently
export async function acquireTokenSilently() {
    try {
        await msalInstance.handleRedirectPromise();
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0){
            msalInstance.loginRedirect();
        }
        const silentRequest = {
            account: accounts[0], // assuming you have only one account
            scopes: [`${B2CScope()}`] // specify the scopes you need
        };
        
        await msalInstance.acquireTokenSilent(silentRequest);
    } catch (error: any) {
        if(error.errorCode === "interaction_required")
            msalInstance.logoutRedirect();
        console.error('Silent token acquisition failed:', error);
        // If silent token acquisition fails, you may need to handle the error appropriately
        // For example, you might need to prompt the user to sign in again
    }
}
export class AuthError extends Error {
    // This is a short code describing the error
    errorCode: string="";
    // This is a descriptive string of the error,
    // and may also contain the mitigation strategy
    errorMessage: string="";
    // Name of the error class
    name = "AuthError";
}
export function B2CScope(){
    return `https://${b2cTenant()}.onmicrosoft.com/${b2cClientId()}/${b2cScopeEndPoint()}`;
}